export default {
  name: 'vue-treeselect--arrow'
};